const RESOURCE_NAME = '/shipments-address-templates';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});